import React, { useState, useEffect } from "react";
import {
  MdDashboard,
  MdPeople,
  MdAccountBox,
  MdOutlineBusinessCenter,
  MdOutlineLibraryAdd,
  MdOutlineViewList,
} from "react-icons/md";
import { BiLogOutCircle } from "react-icons/bi";
import { Link } from "react-router-dom";
import "./style.min.css";
import SidebarMenu from "./SidebarMenu";
const Sidenavbar = () => {
  const [windowDimension, setWindowDimension] = useState(window.innerWidth);
  const [isOpen, setIsOpen] = useState(true);
  const detectSize = () => {
    setWindowDimension(window.innerWidth);
    if (windowDimension < 768) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  useEffect(() => {
    if (windowDimension < 768) {
      setIsOpen(false);
    }
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);

  const [item, setItem] = useState([
    {
      title: "Lssf Trust",
      icon: <MdPeople className="my__nav__icon" />,
      dropDown: [
        {
          title: "For Swing Machine",
          icon: <MdAccountBox className="my__nav__icon" />,
          href: "/dashboard/lssf/sewing-applications",
        },
        {
          title: "For Health Check-up",
          icon: <MdOutlineLibraryAdd className="my__nav__icon" />,
          href: "/dashboard/lssf/health-applications",
        },
        {
          title: "For Tricycle",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/lssf/tricycle-applications",
        },
        {
          title: "For Cataract Surgery Requests",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/lssf/cataract-applications",
        },
        {
          title: "For Farmer Spray Machine",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/lssf/farmer-applications",
        },
        {
          title: "For Run Paritcipation",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/lssf/running-competition",
        },
        {
          title: "For Inquiries",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/lssf/contact-enquiries",
        },
        {
          title: "For Donation",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/lssf/donations",
        },
      ],
    },
    //   {
    //   title: "Mbbs Duniya Mgmt",
    //   icon: <MdPeople className="my__nav__icon" />,
    //   dropDown: [
    //     {
    //       title: "Counseling Details",
    //       icon: <MdAccountBox className="my__nav__icon" />,
    //       href: "/dashboard/mbbs/counseling-details",
    //     },
    //     {
    //       title: "Contact Enquiry",
    //       icon: <MdOutlineLibraryAdd className="my__nav__icon" />,
    //       href: "/dashboard/mbbs/contact-enquiry",
    //     },
    //     {
    //       title: "Students List",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/mbbs/students-list",
    //     },
    //     {
    //       title: "College List",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/mbbs/college-list",
    //     },
    //     {
    //       title: "Blog List",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/mbbs/blog-list",
    //     }
    //   ],
    // },
  ]);
  return (
    <aside className="left-sidebar" data-sidebarbg="skin5">
      {/* <!-- Sidebar scroll--> */}
      <div className="scroll-sidebar">
        {/* <!-- Sidebar navigation--> */}
        <nav className="sidebar-nav">
          <ul id="sidebarnav" className="pt-4">
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="dash_board"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Dashboard</span>
              </Link>
            </li>
            {item.map((item, index) => {
              return (
                <SidebarMenu
                  title={item.title}
                  icon={item.icon}
                  dropDown={item.dropDown}
                  key={index}
                />
              );
            })}
            {/* <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/certificates"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Certificates</span>
              </Link>
            </li>
  <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/media"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Media</span>
              </Link>
            </li>
              <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/gallery"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Gallery</span>
              </Link>
            </li>

                <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/events"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Events Gallery</span>
              </Link>
            </li> */}
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/logout"
                aria-expanded="false"
              >
                <BiLogOutCircle
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Logout</span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidenavbar;
